import React from 'react';
import { ChevronRight } from 'lucide-react';

interface RelatedBoardButtonProps {
  relatedBoardTitle: string;
  relatedOrdersCount: number;
  onClick: () => void;
  isLoading?: boolean;
}

const RelatedBoardButton: React.FC<RelatedBoardButtonProps> = ({
  relatedBoardTitle,
  relatedOrdersCount,
  onClick,
  isLoading = false,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={isLoading}
      className="flex items-center gap-2 px-3 py-2 rounded-lg border border-blue-300 bg-blue-50 hover:bg-blue-100 text-blue-700 hover:text-blue-800 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-medium"
      title={`ดูใบงานในบอร์ด ${relatedBoardTitle}`}
    >
      <span className="truncate">
        พบ <span className="font-bold">{relatedOrdersCount}</span> ใบงานในบอร์ด <span className="font-semibold">{relatedBoardTitle}</span>
      </span>
      <ChevronRight className="h-4 w-4 flex-shrink-0" />
    </button>
  );
};

export default RelatedBoardButton;
